import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AbcCoreModule } from '@barthauer/abc/core';
import { _AbcButtonComponent, _AbcSelectBoxComponent } from '@barthauer/abc/ui-components';
import { AbcDropDownBoxComponent } from '@barthauer/abc/ui-components/abc-drop-down-box';
import { _AbcGridComponent } from '@barthauer/abc/ui-components/abc-grid';
import { AbcPopupComponent } from '@barthauer/abc/ui-components/abc-popup';
import { AbcRadioGroupComponent } from '@barthauer/abc/ui-components/abc-radio-group';
import { DxDataGridModule } from 'devextreme-angular';
import { ObjectSelectionItemsComponent } from './object-selection-items.component';
import { ObjectsSetsComponent } from './objects-sets.component';
import { ObjectsSetsService } from './objects-sets.service';

@NgModule({
  imports: [
    CommonModule,
    _AbcGridComponent,
    AbcPopupComponent,
    DxDataGridModule,
    _AbcButtonComponent,
    AbcCoreModule,
    AbcDropDownBoxComponent,
    _AbcSelectBoxComponent,
    AbcRadioGroupComponent,
  ],
  declarations: [ObjectsSetsComponent, ObjectSelectionItemsComponent],
  exports: [ObjectsSetsComponent, ObjectSelectionItemsComponent],
  providers: [ObjectsSetsService],
})
export class ObjectsSetsModule {}
